import Vue from 'vue'
import { Path, Values } from 'vue-i18n'
import { imageUrl } from '@/shared/utils/images'
import { shortenString } from '@/shared/utils/shorten-string'
import { translate } from '@/shared/utils/branded-translation'

export function applyVueExtensions() {
  Vue.mixin({
    methods: {
      /**
       * Branded translate
       */
      $bt(key: Path, values?: Values) {
        return translate(key, values)
      },

      $imageUrl(url: string, width?: number, height?: number) {
        return imageUrl(url, width, height)
      },

      $shortenString(text: string | undefined, length: number) {
        return typeof text === 'string' ? shortenString(text, length) : ''
      },
    },
  })
}
